import { ApiService } from "./ApiService";

const baseUrl = "/services/rateagreement/api/util";

class UtilService extends ApiService {
    async getDebtNo() {
        const response = await fetch(baseUrl + "/debtnumber", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-current-page": document.location.href,
            },
        });
        const debtNo = await this.handleResponse(response);
        return debtNo.text();
    }

    async isIbanValid(iban: string): Promise<boolean> {
        const request = Object.assign({ iban: iban });
        const response = await fetch(baseUrl + "/validate", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request),
        });

        const result = await this.handleResponse(response);
        return result.text().then(function (result) {
            return JSON.parse(result);
        });
    }
}

export default new UtilService();
